import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
import { Button } from '@neo4j-ndl/react';
import { useState } from 'react';
import { ButtonGroup } from './button-group';
const isThunkComponent = (t) => typeof t === 'function';
export function ShowAll({ initiallyShown, children, isButtonGroup, }) {
    const [isExpanded, setIsExpanded] = useState(false);
    const toggleExpanded = () => setIsExpanded((e) => !e);
    const itemCount = children.length;
    const shouldHaveControls = itemCount > initiallyShown;
    const shown = isExpanded ? itemCount : initiallyShown;
    const leftToShow = itemCount - shown;
    if (itemCount === 0) {
        return null;
    }
    const currentChildren = children
        .slice(0, shown)
        .map((c) => (isThunkComponent(c) ? c() : c));
    return (_jsxs(_Fragment, { children: [isButtonGroup === true ? (_jsx(ButtonGroup, { children: currentChildren })) : (_jsx("div", { style: { all: 'inherit' }, children: currentChildren })), shouldHaveControls && (_jsx(Button, { fill: "text", size: "small", onClick: toggleExpanded, children: isExpanded ? 'Show less' : `Show all (${leftToShow} more)` }))] }));
}
//# sourceMappingURL=show-all.js.map